export default "__VITE_ASSET__9mT8F3Nz__"